import "core-js/modules/web.dom-collections.iterator.js";
import React, { useState } from 'react';
import { IconButton, StandardButton } from '@eika/button';
import { IconTypes } from '@eika/icon';
import { Modal, ModalTypes } from '@eika/modal';
const PepHelpModal = _ref => {
  let {
    className
  } = _ref;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const closeModal = () => setIsModalOpen(false);
  const showModal = e => {
    e.preventDefault();
    setIsModalOpen(true);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(IconButton, {
    className: className,
    onClick: showModal,
    icon: IconTypes.INFO_20,
    id: "help-icon-PEP",
    screenReaderText: "Hjelpetekst"
  }), /*#__PURE__*/React.createElement(Modal, {
    onClose: closeModal,
    show: isModalOpen,
    id: "helpermodal__modal",
    type: ModalTypes.STANDARD,
    appNamespace: "kyc-declaration.app"
  }, /*#__PURE__*/React.createElement("div", {
    role: "tooltip",
    id: "helpermodal",
    className: "content__children"
  }, /*#__PURE__*/React.createElement("p", null, "Med politisk eksponert person (PEP) menes en person som innehar eller har innehatt en stilling eller et verv som"), /*#__PURE__*/React.createElement("ol", null, /*#__PURE__*/React.createElement("li", null, "statsoverhode, regjeringssjef, minister eller assisterende minister"), /*#__PURE__*/React.createElement("li", null, "medlem av nasjonalforsamling"), /*#__PURE__*/React.createElement("li", null, "medlem av styrende organ i politisk parti"), /*#__PURE__*/React.createElement("li", null, "medlem av h\xF8yere rettsinstans som treffer beslutning som ikke eller bare unntaksvis kan ankes"), /*#__PURE__*/React.createElement("li", null, "medlem av styre i riksrevisjon, revisjonsdomstol eller sentralbank"), /*#__PURE__*/React.createElement("li", null, "ambassad\xF8r, charg\xE9 d'affaires eller milit\xE6r offiser av h\xF8yere rang"), /*#__PURE__*/React.createElement("li", null, "medlem av administrativt, ledende eller kontrollerende organ i statlig foretak"), /*#__PURE__*/React.createElement("li", null, "direkt\xF8r, styremedlem eller annen person i \xF8verste ledelse i internasjonal organisasjon")), /*#__PURE__*/React.createElement("p", null, "Som n\xE6re familiemedlemmer regnes foreldre, ektefelle, samboer og barn, samt barns ektefelle eller samboer."), /*#__PURE__*/React.createElement("p", null, "Med kjent medarbeider menes en person som reelt sett eier eller kontrollerer et selskap sammen med en PEP, eller er n\xE6r forretningsforbindelse, eksempelvis en fast leverand\xF8r. Det er ikke det samme som en vanlig kollega."), /*#__PURE__*/React.createElement(StandardButton, {
    className: "help-modal-button",
    onClick: closeModal
  }, "Lukk"))));
};
export default PepHelpModal;